module.exports = __webpack_public_path__ + "static/pandecoco-04456bc19402d949e007ea44f9defcc0.jpg";